import { LegalClientInvestmentPurposeAndNatureEntity } from 'api/types/entity';
import { TFunc } from 'libs/i18n';

import { InvestmentPurposeAndNatureFormType } from '../../forms/investmentPurposeAndNatureForm';

export const parseInvestmentPurposeAndNatureValue = (
  t: TFunc,
  data?: LegalClientInvestmentPurposeAndNatureEntity
) => {
  const values:
    | InvestmentPurposeAndNatureFormType['investmentPurposeAndNature'] = data
    ? {
        otherInvestmentObjective: data.otherInvestmentObjective,
        otherPlannedServices: data.otherPlannedServices,
        investmentDuration: {
          label: t(
            `client.legal.investmentPurposeAndNature.investmentDuration.types.${data.investmentDuration}`
          ),
          value: data.investmentDuration,
        },
        investmentObjectives: data.investmentObjectives?.map((v) => ({
          label: t(
            `client.legal.investmentPurposeAndNature.investmentObjectives.types.${v}`
          ),
          value: v,
        })),
        plannedServices: data.plannedServices?.map((v) => ({
          label: t(
            `client.legal.investmentPurposeAndNature.plannedServices.types.${v}`
          ),
          value: v,
        })),
      }
    : ({} as InvestmentPurposeAndNatureFormType['investmentPurposeAndNature']);

  return values;
};
